/** @format */

import { useQuery } from "@tanstack/react-query";
import service from "../utils/service"

const useGetChannels = () => {
  const regions = useQuery({
    queryKey: ["getChannels"],
    queryFn: () => service.getChannels(),
    select: (data) => data.data,
    cacheTime: Infinity,
    staleTime: Infinity
  });
  return regions;
};

export default useGetChannels;